import styles from './FilterErrorMessage.module.scss';

export const FilterErrorMessage = ({ message }: { message: string }) => {
  return <span className={styles.errorText}>{message}</span>;
};
